<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="700px"
    append-to-body
    @open="onOpen"
    @close="onClose"
  >
    <div v-loading="loading" style="min-height: 80px;">
      <div v-if="!loading && detail" class="follow-detail-block" style="padding: 12px; background: #f5f7fa; border-radius: 4px;">
        <template v-if="type === 'student'">
          <div><strong>跟进状态：</strong>{{ detail.state }}</div>
          <div v-if="detail.state === 'f'"><strong>退出时间：</strong>{{ detail.quitTime || '—' }}</div>
          <div><strong>跟进摘要：</strong>{{ detail.followSummary }}</div>
          <div><strong>顾问老师：</strong>{{ detail.adviserName || '—' }}</div>
          <div><strong>推荐人（营销老师）：</strong>{{ detail.marketName }}</div>
          <div><strong>缴费时间：</strong>{{ detail.paymentDate }}</div>
          <!-- 已签约(s)时不显示申请学校和赴日时间 -->
          <div v-if="detail.state !== 's'||detail.state !== 'a'"><strong>申请学校：</strong>{{ detail.applySchool }}</div>
          <div v-if="detail.state !== 's'||detail.state !== 'a'"><strong>赴日时间：</strong>{{ detail.abroadDate }}</div>
        </template>
        <template v-else-if="type === 'jap'">
          <div><strong>跟进状态：</strong>{{ detail.state }}</div>
          <div v-if="detail.state === 'f'"><strong>退出时间：</strong>{{ detail.quitTime || '—' }}</div>
          <div><strong>跟进摘要：</strong>{{ detail.summary }}</div>
          <div><strong>顾问老师：</strong>{{ detail.adviserName || '—' }}</div>
          <div><strong>推荐人（营销老师）：</strong>{{ detail.marketName }}</div>
          <div><strong>缴费时间：</strong>{{ detail.paymentDate }}</div>
          <div><strong>学习课程：</strong>{{ detail.courseName }}</div>
          <div><strong>缴费金额：</strong>{{ detail.paymentAmount }}</div>
          <div><strong>申请学校：</strong>{{ detail.applySchool }}</div>
          <div><strong>赴日时间：</strong>{{ detail.abroadDate }}</div>
        </template>
        <template v-else-if="type === 'mingye'">
          <div><strong>跟进状态：</strong>{{ detail.state }}</div>
          <div v-if="detail.state === 'f'"><strong>退出时间：</strong>{{ detail.quitTime || '—' }}</div>
          <div><strong>跟进摘要：</strong>{{ detail.followSummary }}</div>
          <div><strong>顾问老师：</strong>{{ detail.adviserName || '—' }}</div>
          <div><strong>推荐人（营销老师）：</strong>{{ detail.marketName || '—' }}</div>
          <div><strong>缴费时间：</strong>{{ detail.paymentDate }}</div>
          <div><strong>学习课程：</strong>{{ detail.courseName }}</div>
          <div><strong>缴费金额：</strong>{{ detail.paymentAmount }}</div>
          <div><strong>申请学校：</strong>{{ detail.applySchool }}</div>
          <div><strong>赴日时间：</strong>{{ detail.abroadDate }}</div>
        </template>
      </div>
      <div v-else-if="!loading && !detail" style="padding: 20px; color: #909399;">暂无数据</div>
    </div>
  </el-dialog>
</template>

<script>
import url from '@/plugins/urlHelper.js';

const TITLE_MAP = { student: '留学跟进详情', jap: '日语跟进详情', mingye: '鸣野跟进详情' };

export default {
  name: 'FollowDetailDialog',
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' }, // student | jap | mingye
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      loading: false,
      detail: null
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit('update:visible', v);
      }
    },
    dialogTitle() {
      const name = (this.row && this.row.realName) ? this.row.realName : '';
      const title = TITLE_MAP[this.type] || '跟进详情';
      return name ? `${name} - ${title}` : title;
    }
  },
  methods: {
    onOpen() {
      this.detail = null;
      const studentID = this.row && this.row.id;
      if (!studentID || !this.type) {
        this.loading = false;
        return;
      }
      this.loading = true;
      if (this.type === 'student') {
        const _this = this;
        $.get(url.getStu('GetFollowDetail_Student'), { studentID }, function (data) {
          _this.detail = data.student || null;
          _this.loading = false;
        });
      } else if (this.type === 'jap') {
        const _this = this;
        $.get(url.getStu('GetFollowDetail_Jap'), { studentID }, function (data) {
          _this.detail = data.japInfo || null;
          _this.loading = false;
        });
      } else if (this.type === 'mingye') {
        const _this = this;
        $.get(url.getMingye('GetFollowDetail_Mingye'), { studentID }, function (data) {
          _this.detail = data;
          _this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    onClose() {
      this.detail = null;
      this.loading = false;
    }
  }
};
</script>
